import React from 'react';
import { Download } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import { toast } from 'react-toastify';
import ToastErrorMessage from '@components/toast/ToastErrorMessage';
import { downloadFileFromUrl, generateDownloadLink } from '@utils/file-utils';
import { cloneDeep } from 'lodash';
import { IVoucherPopupValues } from './types';
import { IFile } from '@models/file';
import { CDN_URL } from '@utils';
import { MAIN_THEME } from '@styles';
import UploadFileFormField from '@components/form-fields/UploadFileFormField';

interface ISupportingDocuments {
  values: IVoucherPopupValues;
  setValues: (state: IVoucherPopupValues) => void;
  currentPaymentId: string;
  classes: Record<string, string>;
}

const SupportingDocuments: React.FC<ISupportingDocuments> = ({
  values,
  setValues,
  currentPaymentId,
  classes,
}) => {
  const handleUploadFile = (file: File) => {
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 10) {
      toast.error(
        <ToastErrorMessage>Max file size should be 10 MBs</ToastErrorMessage>
      );
    } else {
      const newValues = cloneDeep(values);
      newValues.supportingDocuments.push(file);
      setValues(newValues);
    }
  };

  const handleDeleteFile = (index: number) => {
    const newValues = cloneDeep(values);
    newValues.supportingDocuments.splice(index, 1);
    setValues(newValues);
  };

  const handleDeleteSupportingfile = (index: number) => {
    const newValues = cloneDeep(values);
    newValues.incomingDocuments.splice(index, 1);
    setValues(newValues);
  };

  const downloadDocument = (fileId: string, fileName: string) => {
    const url = generateDownloadLink(
      fileId,
      'Accounting-Payments',
      currentPaymentId,
      'Accounting-all',
      'PaymentDocuments'
    );

    downloadFileFromUrl(url, fileName);
  };

  return (
    <>
      <UploadFileFormField
        value={''}
        onUpload={(file) => {
          handleUploadFile(file);
        }}
        name="supportingDocuments"
        title="Upload Supporting Documents"
        placeholder="Upload a document"
        iconUrl={`${CDN_URL}/icons/upload-field-primary-new.svg`}
        allowedFileTypes={[]}
      />
      {values.incomingDocuments.map((file: IFile, index: number) => (
        <div className={classes.uploadedFileContainer} key={index}>
          <span className={classes.uploadedFileName}>{file.fileName}</span>

          <button
            className={classes.uploadedFileClearIcon}
            onClick={() => {
              downloadDocument(file.id, file.fileName);
            }}
          >
            <Download htmlColor={MAIN_THEME.color.black47} fontSize="small" />
          </button>

          <button
            className={classes.uploadedFileClearIcon}
            onClick={() => {
              handleDeleteSupportingfile(index);
            }}
          >
            <ClearIcon htmlColor={MAIN_THEME.color.black47} fontSize="small" />
          </button>
        </div>
      ))}
      {values.supportingDocuments.map((file: File, index: number) => (
        <div className={classes.uploadedFileContainer} key={index}>
          <span className={classes.uploadedFileName}>{file.name}</span>
          <button
            className={classes.uploadedFileClearIcon}
            onClick={() => {
              handleDeleteFile(index);
            }}
          >
            <ClearIcon htmlColor={MAIN_THEME.color.black47} fontSize="small" />
          </button>
        </div>
      ))}
    </>
  );
};

export default SupportingDocuments;
